import React, { useState, useEffect } from 'react';
// import { Table, Button, Modal, Form, Row, Col, DatePicker } from 'antd';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox, DatePicker, FloatButton } from 'antd';

import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css'; // Assuming style.module.css is in the same directory
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import { AiFillDelete, AiFillEdit } from 'react-icons/ai'
import { toast, ToastContainer } from 'react-toastify';
import { Container, Image } from 'react-bootstrap';
import { FaRegCopy } from "react-icons/fa";

import QRCode from 'qrcode.react';
import { IoMdCloseCircle } from 'react-icons/io';
import LocationMatrix from './components/LocationMetric';

import { FaFilter } from "react-icons/fa6";
import { BiSolidLeftArrow } from "react-icons/bi";



const Metric = ({ user, type }) => {
    const [locations, setLocations] = useState([]);


    const [isLoading, setIsLoading] = useState(true);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
    });

    const [selectedLocation, setSelectedLocation] = useState(null)

    const [form] = Form.useForm();


    const [filterLocationName, setFilterLocationName] = useState('');
    const [filterFromDate, setFilterFromDate] = useState(null);
    const [filterToDate, setFilterToDate] = useState(null);
    // const [reschedulingData, setReschedulingData] = useState({});

    const [showFilters, setShowFilters] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
                setShowFilters(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (user) {
            getLocations();
        }

    }, [user]);

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getLocations(current, pageSize);
    };

    const getLocations = async (page = 1, limit = 10) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getLocationList({
                page: page,
                limit: limit,
                filterLocationName: filterLocationName
            });

            setLocations(res.data.locations);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClearFilter = () => {
        setFilterFromDate(null);
        setFilterToDate(null);
        setFilterLocationName('');
        getLocations(1, 10, true);
    };



    const columns = [
        {
            title: 'Locations',
            dataIndex: 'locationName',
            key: 'locationName',
            render: (text, record) => (
                <div>
                    <div>{record.locationName}</div>
                    <div><LocationMatrix location={record} fromDate={filterFromDate} toDate={filterToDate} /></div>
                </div>
            )
        },
    ];


    return (
        <Container>

            <ToastContainer></ToastContainer>
            <Form layout={'vertical'} >
                <button onClick={()=>setShowFilters(!showFilters)} className={`${styles['filter-button']} ${scrolled ? styles['show'] : ''}`}><FaFilter /></button>
                <div className={`${styles['filter']} ${(scrolled && showFilters) ? styles['fixed-filter'] : ''} mt-4`}>
                    {(scrolled && showFilters) ? <BiSolidLeftArrow className={styles['pointer']} /> : undefined}
                    <div className={styles['filter-left']}><Input value={filterLocationName} onChange={(e)=>setFilterLocationName(e.target.value)} placeholder='Location Name' /></div>
                    <div className={styles['filter-right']}>
                        <DatePicker value={filterFromDate} placeholder='Date From' onChange={(date) => setFilterFromDate(date)} />
                        <DatePicker value={filterToDate} placeholder='Date To' onChange={(date) => setFilterToDate(date)} />
                        <Button onClick={() => { getLocations() }} type="primary">Filter</Button>
                        <Button onClick={handleClearFilter} className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} />
                    </div>
                </div>
            </Form>
            <div className='mt-4'>
                <Table
                    loading={isLoading}
                    dataSource={locations}
                    columns={columns}
                    rowKey="_id"
                    pagination={pagination}
                    onChange={handleTableChange}
                    className={styles['data-list']}
                    bordered
                    size="middle"
                />
            </div>



        </Container>
    );

};

Metric.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string
};
const MetricProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null
});
export default connect(MetricProps, {})(Metric);
 